export { default, getStaticProps } from "app/smartphone/page";
